import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const isMobile = () => window.innerWidth <= 768;

export const ToastConfig = {
  position: isMobile() ? "top-center" : "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
  theme: "dark"
};

const ComingSoonToast = () => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column', 
    gap: '8px',
    width: isMobile() ? '80vw' : 'auto'
  }}>
    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>Coming Soon</div>
    <div style={{ fontSize: '14px' }}>
      Get updates on our progress by following our twitter.
    </div>
    <button 
      onClick={() => window.open('https://x.com/rayvo_xyz', '_blank')}
      style={{
        marginTop: '8px',
        padding: '8px 16px',
        backgroundColor: '#fff',
        color: '#000',
        border: 'none',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        width: isMobile() ? '100%' : 'auto'
      }}
    >
      Follow @rayvo_xyz
    </button>
  </div>
);

export const showToast = {
  success: (message) => toast.success(message),
  error: (message) => toast.error(message),
  info: (message) => toast.info(message),
  warning: (message) => toast.warning(message),
  comingSoon: () => toast(ComingSoonToast, {
    ...ToastConfig,
    autoClose: 5000,
    style: {
      width: isMobile() ? '90%' : 'auto',
      maxWidth: isMobile() ? '400px' : '600px',
      margin: isMobile() ? '0 auto' : undefined
    }
  })
};
